import React, { Component } from 'react';
import intl from 'react-intl-universal';
import { getParameterByName } from '../../querystring.js';

const locales = {
    'pt-BR': require('../../locales/pt-BR.json'),
    'en-US': require('../../locales/en-US.json'),
    'es-ES': require('../../locales/es-ES.json')
  };

class Header extends Component {

    constructor() {
        super();

        const querystring = getParameterByName('lang');

        console.log(querystring)

        const language = querystring ? querystring : navigator.language;
    
        const currentLocale = locales[language] ? language : 'pt-BR';
    
        intl.init({
          currentLocale,
          locales
        });
      }

    render() {
        return (
            <div className="block">
                <div className="container">
                    <div className="row-machine">
                        <div className="col-lg-6 col-sm-6">
                            <h1 id="title" className="title">{intl.get('header.title')}<br />{intl.get('header.subtitle')}</h1>
                            <p id="subtitle" className="subtitle">{intl.get('header.calculadora')}</p>
                        </div>
                        <div className="col-lg-4 col-lg-offset-2 col-sm-6">
                            <img className="img-responsive img_calculadora" src="/imgs/calc.png" alt="Calculadora NPS" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Header;